var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenUtility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.00024C5.92487 1.00024 1 5.92511 1 12.0002C1 18.0754 5.92487 23.0002 12 23.0002C18.0751 23.0002 23 18.0754 23 12.0002C23 5.92511 18.0751 1.00024 12 1.00024ZM3 12.0002C3 7.02968 7.02944 3.00024 12 3.00024C16.9706 3.00024 21 7.02968 21 12.0002C21 16.9708 16.9706 21.0002 12 21.0002C7.02944 21.0002 3 16.9708 3 12.0002ZM14.6859 9.31432L13.663 6.20392C13.1351 4.59902 10.8649 4.59902 10.337 6.20392L9.31408 9.31432L6.20368 10.3373C4.59878 10.8651 4.59877 13.1354 6.20368 13.6632L9.31408 14.6862L10.337 17.7966C10.8649 19.4015 13.1351 19.4015 13.663 17.7966L14.6859 14.6862L17.7963 13.6632C19.4012 13.1354 19.4012 10.8651 17.7963 10.3373L14.6859 9.31432ZM11.1746 10.0588L12 7.54913L12.8254 10.0588C12.9991 10.5869 13.4133 11.0012 13.9414 11.1749L16.4511 12.0002L13.9414 12.8256C13.4133 12.9993 12.9991 13.4135 12.8254 13.9417L12 16.4514L11.1746 13.9417C11.0009 13.4135 10.5867 12.9993 10.0586 12.8256L7.54889 12.0002L10.0586 11.1749C10.5867 11.0012 11.0009 10.5869 11.1746 10.0588Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenUtility);
export default __webpack_public_path__ + "static/media/token-utility.7460f412b8aa951a569a213dfec7d37f.svg";
export { ForwardRef as ReactComponent };